import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public setItem(key: string, value: string | number | boolean): void {
    if (typeof window !== 'undefined') {
      try {
        const item = JSON.stringify(value);
        localStorage.setItem(key, item);
      } catch (error) {
        console.error('Error saving to localStorage', error);
      }
    }
  }

  public getItem<T>(key: string): T | null {
    if (typeof window !== 'undefined') {
      try {
        const item = localStorage.getItem(key);
        return item ? (JSON.parse(item) as T) : null;
      } catch (error) {
        console.error('Error reading from localStorage', error);
        return null;
      }
    }
    return null;
  }

  public removeItem(key: string): void {
    if (typeof window !== 'undefined') {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error('Error removing from localStorage', error);
      }
    }
  }
}
